import { render, staticRenderFns } from "./addAutoPartDialog.vue?vue&type=template&id=97974e72&scoped=true&"
import script from "./addAutoPartDialog.vue?vue&type=script&lang=js&"
export * from "./addAutoPartDialog.vue?vue&type=script&lang=js&"
import style0 from "./addAutoPartDialog.vue?vue&type=style&index=0&id=97974e72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97974e72",
  null
  
)

component.options.__file = "addAutoPartDialog.vue"
export default component.exports